import React, {useEffect, useState} from "react";
import AuthenticationBlock from "../../../../platform/src/blocks/AuthenticationBlock";
import ko from "knockout";
import {services} from "@offline/components/SignIn/SocialLogin";
import InfoAuthentication from "../../../../platform/src/components/Authentication/InfoAuthentication";
import Icons from "../../../../platform/src/components/Icons";

const getDefaultValue = (value, type) => {
    let _value = value;

    if (type === 'checkbox' || type === 'disclaimer') {
        _value = _value === 'true' ? true : false
    }
    
    return _value
}

const getRegistrationFields = ($app) => {
    return $app.event().registrationFields().map((field) => ({
        id: field.id(),
        type: field.type(),
        name: field.name(),
        defaultValue: getDefaultValue(field.defaultValue() || '', field.type()),
        required: field.required(),
        label: field.label(),
        placeholder: field.placeholder(),
        description: field.description(),
        options: field.options()?.map((option) => ({
            id: option.id(),
            value: option.value(),
            label: option.label(),
        })),
        max: field.max(),
        min: field.min(),
        regexp: field.regexp(),
    })) || [];
}

export default ({$app, koVisible, onLogin, onWindowResize}) => {
    const [visible, setVisible] = useState(false);
    const moduleAuth = $app.event().moduleAuth.getCleanData();
    const moduleSettings = $app.event().moduleSettings.getCleanData() || null;
    const hideInfoBlock = moduleSettings.hideInfoBlock || false;
    const isAuthRequired = $app.event().moduleAuth.require();

    useEffect(() => {
        ko.computed(() => {
            setVisible(koVisible());
        });

        const loginPage = document.getElementById('login-page');
        loginPage.style.maxWidth = isAuthRequired ? '800px' : '100%';
    }, []);

    if (!visible) {
        return null;
    }

    const customDescription = $app.event().moduleAuth.customDescription()
        || $app.event().moduleSettings.loginSubtitle()
    ;

    return (
        <div className={`player-auth login-page`}>
            <div className={`${(!hideInfoBlock && isAuthRequired) ? 'two-column' : ''}`}>
                {(!hideInfoBlock && isAuthRequired) && (
                    <InfoAuthentication
                        $locale={$app.require('locale')}
                        posterImage={moduleSettings.posterImage ?? ''}
                        eventName={$app.event().name()}
                        eventTitle={$app.event().moduleSettings.eventTitle() ?? $app.event().name()}
                        hideEventTitle={moduleSettings.hideEventTitle}
                        eventSubtitle={$app.event().moduleSettings.eventSubtitle() ?? ''}
                        hideEventSubtitle={moduleSettings.hideEventSubtitle ?? false}
                        date={$app.event().moduleSettings.date() ?? ''}
                        eventTimeStart={$app.event().timeStart()}
                        eventTimeStop={$app.event().timeStop()}
                        hideDate={moduleSettings.hideDate || false}
                        hideFormat={!!moduleSettings ? moduleSettings.hideFormat : false}
                        eventParticipationType={$app.event().participationType()}
                        onWindowResize={() => setTimeout(onWindowResize, 10)}
                    />
                )}
                <AuthenticationBlock
                    $locale={$app.require('locale')}
                    eventKey={$app.event().eventKey()}
                    eventName={$app.event().name()}
                    timeStart={$app.event().timeStart()}
                    customDescription={customDescription}
                    eventPremoderation={$app.event().moduleAuth.accessPreModeration()}
                    authRequired={isAuthRequired}
                    participationType={$app.event().participationType()}
                    moduleSettings={moduleSettings}
                    moduleAuth={moduleAuth}
                    loginWithEmailEnabled={moduleAuth.email}
                    loginWithNameEnabled={moduleAuth.guest}
                    loginWithPhoneEnabled={moduleAuth.phone}
                    hideInfoBlock={hideInfoBlock}
                    externalServices={services.filter((name) => moduleAuth[name])}
                    ssoIconUrl={moduleAuth.ssoIconUrl}
                    registrationFields={getRegistrationFields($app)}
                    onWindowResize={() => setTimeout(onWindowResize, 10)}
                    onLogin={onLogin}
                    useVendorBranding={$app.event().moduleBranding.showComdiBanner()}
                    corporateMail={moduleAuth.corporateMail ?? false}
                    participationFormatLabels={$app.event().moduleAuth.participationFormatLabels()}
                    registrationType={$app.event().moduleAuth.registrationType() ?? 'hybrid'}
                />
            </div>
            {$app.event().moduleBranding.showComdiBanner() && (
                <footer className="auth-footer">
                    <a href="https://www.comdi.com/?utm_source=platform&utm_medium=registration_form&utm_campaign=users" target="_blank">
                        <Icons name="comdi_logo" />
                    </a>
                </footer>
            )}
        </div>
    );
}
